var LinkVariant = /*#__PURE__*/function (LinkVariant) {
  LinkVariant["default"] = "default";
  LinkVariant["neutral"] = "neutral";
  LinkVariant["invert"] = "invert";
  LinkVariant["destructive"] = "destructive";
  return LinkVariant;
}({});
export { LinkVariant };